import http from '../lib/http';

export const LOG_POST_START = 'LOG_POST_START';
export const LOG_POST_ERROR = 'LOG_POST_ERROR';
export const LOG_POST_SUCCESS = 'LOG_POST_SUCCESS';

export const ADD_LOG = 'ADD_LOG';

export function addLog(logAction, userId) {
    return {
        type: 'ADD_LOG',
        payload: {logAction, userId}
    };
}

export function uploadLogs(logs, deviceId) {
    return {
        type: 'LOG_POST',
        payload: {
            promise: postUploadLogs(logs, deviceId)
        }
    };
}

async function postUploadLogs(logs, deviceId) {
    const res = await http.post(`/app/logs`, {
        query: {
            did: deviceId
        },
        body: logs.toList()
    });
    if (res.status < 300) return res.json();
    throw res;
}





// WEBPACK FOOTER //
// ./src/common/logs/actions.js